import type { FleetExportData } from './fleet-export-schema';

export const FLEET_EXPORT_DECIMAL_PLACES = {
  vehicleLength: 2,
  vehicleWidth: 2,
  vehicleHeight: 2,
  volumeCapacity: 2,
  cargoSpaceLength: 2,
  cargoSpaceWidth: 2,
  cargoSpaceHeight: 2,
  coilWellLength: 2,
  mainTank: 2,
  additionalTank: 2,
  adBlueTank: 2,
  generatorFuelTank: 2,
  vehicleValue: 2,
  selfDeposit: 2,
  buyout: 2,
  installment: 2,
  margin: 2,
  thirdPartyLiabilityAnnualCost: 2,
  thirdPartyLiabilityInsuranceSum: 2,
  comprehensiveAnnualCost: 2,
  comprehensiveInsuranceSum: 2,
} as const satisfies Partial<Record<keyof FleetExportData, number>>;
